import remote from '../remote'
import moment from 'moment'

const state = {
  archivedOrders: [],
  ordersAsResources: [],
  dateRangedOrders: [],
  calendarEvents: [],
  customerPlaces: []
}

const orderName = (order, product, driver) => {
  let driverName = ''
  if (driver !== undefined) {
    driverName = driver.userName
  }
  if (order.data.DeliveryPlaceCity !== undefined) {
    let quantity = order.data.Quantity
    let comment = ''
    let deleted = ''
    if ((order.data.InternDeliveryPlaceComments !== undefined && order.data.InternDeliveryPlaceComments !== null && order.data.InternDeliveryPlaceComments !== '') || (order.data.DeliveryPlaceComments !== undefined && order.data.DeliveryPlaceComments !== null && order.data.DeliveryPlaceComments !== '')) {
      comment = '* '
    }
    if (order.state === 'makulerad_externt') {
      deleted = '!! MAKULERAD !! '
    }
    return (order.data.CustomerPlaces === undefined ? '' : comment + order.data.CustomerPlaces.length + 'st') + deleted + ' ' + order.data.DeliveryPlaceCity + ', ' + quantity + 'ton' + ' ' + (product === undefined ? '!!FEL ARTIKEL!!' : product.data.short) + ' ' + driverName
  } else if (order.data.DeliveryPlaceName !== undefined) {
    return order.data.DeliveryPlaceName
  } else if (order.data.fraktsedelNr !== undefined) {
    let comment = ''
    if (order.data.comment !== undefined && order.data.comment !== null && order.data.comment !== '') {
      comment = '* '
    }
    return comment + order.data.loadingPlaces + ' ' + order.data.fraktsedelNr + (order.data.booked === undefined ? '' : order.data.booked === false ? '' : ' B') + ' ' + driverName
  }
}

const setBorderColor = (order) => {
  if (order.data.ItemId !== undefined) {
    if (order.data.ItemId.startsWith('SOL')) {
      return '#ff0000'
    } else {
      return 'transparent'
    }
  } else if (order.data.deliveryPlaces !== undefined && order.data.deliveryPlaces === 'Sölvesborg') {
    return '#ff0000'
  } else {
    return 'transparent'
  }
}

const startDate = (order) => {
  if (order.data.DecidedDeliveryDate !== undefined && order.data.DecidedDeliveryDate !== '' && order.data.DecidedDeliveryDate !== null) {
    return order.data.DecidedDeliveryDate + ' 06:00'
  } else if (order.type === 'feralcoIntern' && order.data.GroupLoading !== undefined && order.data.dateDelivery !== undefined && order.data.dateDelivery !== '') {
    return moment(order.data.dateDelivery).format('YYYY-MM-DD') + ' 06:05'
  } else if (order.data.dateBooking !== undefined && order.data.dateBooking !== '') {
    return moment(order.data.dateBooking).format('YYYY-MM-DD') + ' 06:05'
  }
  return order.data.DateDeliveryEarly + ' 06:00'
}

const getUrl = (order) => {
  if (order.type === 'feralco') {
    return '/#/feralcoOrdersDetails/' + order.id
  } else if (order.type === 'feralcoIntern') {
    return '/#/feralcoInternOrderDetails/' + order.id
  }
  return ''
}

const endDate = (order) => {
  if (order.data.DecidedDeliveryDate !== undefined && order.data.DecidedDeliveryDate !== null && order.data.DecidedDeliveryDate !== '') {
    return order.data.DecidedDeliveryDate + ' 23:00'
  } else if (order.type === 'feralcoIntern' && order.data.GroupLoading !== undefined && order.data.dateDelivery !== undefined && order.data.dateDelivery !== '') {
    return moment(order.data.dateDelivery).format('YYYY-MM-DD') + ' 23:00'
  } else if (order.data.dateBooking !== undefined && order.data.dateBooking !== '') {
    return moment(order.data.dateBooking).format('YYYY-MM-DD') + ' 23:00'
  }
  return order.data.DateDeliveryLate + ' 23:00'
}

const setColor = (state) => {
  switch (state) {
    case 'ny':
      return ['#ffffff', '#000000']
    case 'uppdaterad':
      return ['#ffffff', '#000000']
    case 'preliminär':
      return ['#F5C523', '#000000']
    case 'accepterad':
      return ['#29B200', '#ffffff']
    case 'skickad':
      return ['#3ECACA', '#000000']
    case 'aktiv':
      return ['#2787DD', '#ffffff']
    case 'lastad':
      return ['#6AABE6', '#ffffff']
    case 'avslutad':
      return ['#4256C4', '#ffffff']
    case 'sparad':
      return ['#F18513', '#ffffff']
    case 'fakturaredo':
      return ['#000000', '#ffffff']
    case 'faktureras':
      return ['#000000', '#ffffff']
    case 'fakturerad':
      return ['#000000', '#ffffff']
    case 'makulerad_externt':
      return ['#000000', '#ffffff']
    default:
      return ['#ffffff', '#000000']
  }
}

const truckId = (order) => {
  if (order.data.truck !== undefined && order.data.truck !== null) {
    return order.data.truck.toString()
  } else if (order.data.GroupLoading !== undefined && order.data.GroupLoading !== null) {
    return order.data.GroupLoading
  }
  return '99999'
}

const getters = {
  ARCHIVED_ORDERS: state => {
    return state.archivedOrders
  },
  DATE_RANGED_ORDERS: state => {
    return state.dateRangedOrders
  },
  DATE_RANGED_ORDERS_ARCHIVE: state => {
    return state.dateRangedOrders
  },
  ORDERS_AS_RESOURCES: state => {
    return state.ordersAsResources
  },
  CUSTOMERPLACES: state => {
    return state.customerPlaces
  },
  CUSTOMERPLACE_NAME: (state, getters) => (name) => {
    const customerName = state.customerPlaces.find(customerPlace => customerPlace.data.slutkundnr === name)
    if (customerName !== undefined && customerName.data.slutkundnamn !== undefined) {
      return customerName.data.slutkundnamn
    }
    return ''
  },
  ARCHIVED_ORDER_BY_ID: (state, getters) => (id) => {
    return state.archivedOrders.find(order => order.id === id)
  },
  ORDERS_NOT_SET_AS_RESOURCES: (state) => {
    return state.ordersAsResources.map(order => (
      {
        id: order.data.GroupLoading,
        sortOrder: 99999999,
        groupId: 'Tankbil',
        title: 'Samlast'
      }
    ))
  },
  ORDERS_AS_EVENTS: (state, getters) => {
    return state.dateRangedOrders.map(order => (
      {
        id: order.id,
        groupId: (order.data.GroupLoading === undefined ? '' : order.data.GroupLoading),
        title: orderName(order, getters.FERALCOARTICLE_BY_NAME(order.data.ItemId), getters.DRIVERS_BY_ID(order.data.activeDriver === undefined ? order.data.driverLoading : order.data.activeDriver)),
        start: startDate(order),
        order: order,
        end: endDate(order),
        url: getUrl(order),
        color: setColor(order.state)[0],
        textColor: setColor(order.state)[1],
        resourceId: truckId(order),
        className: 'calendarOrderEvent' + (order.data.GroupLoading === undefined ? '' : ' ' + 'groupLoadingEvent ' + order.data.GroupLoading),
        borderColor: setBorderColor(order),
        allDay: false,
        editable: true,
        endCustomer: getters.CUSTOMERPLACE_NAME(order.data.DeliveryPlace),
        extendedProps: {
          type: 'order'
        }
      }
    ))
  },
  ORDERS_AS_EXTERNAL_EVENTS: (state, getters) => {
    return state.dateRangedOrders.map(order => (
      {
        id: order.id,
        groupId: (order.data.GroupLoading === undefined ? '' : order.data.GroupLoading),
        title: orderName(order, getters.FERALCOARTICLE_BY_NAME(order.data.ItemId), getters.DRIVERS_BY_ID(order.data.activeDriver === undefined ? order.data.driverLoading : order.data.activeDriver)),
        start: startDate(order),
        order: order,
        end: endDate(order),
        url: getUrl(order),
        color: setColor(order.state)[0],
        textColor: setColor(order.state)[1],
        resourceId: truckId(order),
        className: 'calendarOrderEvent' + (order.data.GroupLoading === undefined ? '' : ' ' + 'groupLoadingEvent ' + order.data.GroupLoading),
        borderColor: setBorderColor(order),
        allDay: false,
        editable: false,
        endCustomer: getters.CUSTOMERPLACE_NAME(order.data.DeliveryPlace),
        extendedProps: {
          type: 'order'
        }
      }
    ))
  },
  CALENDAR_EVENTS: (state, getters) => {
    return state.calendarEvents
  },
  CALENDAR_EVENTS_AS_EVENTS: (state, getters) => {
    return state.calendarEvents.map(e => (
      {
        id: e.id,
        title: e.title,
        start: e.start,
        end: e.end,
        color: e.color === null ? '#000000' : e.color,
        textColor: '#ffffff',
        resourceId: e.resourceId,
        className: 'calendarOrderEvent calendarCustomEvent',
        borderColor: 'transparent',
        allDay: false,
        editable: true,
        extendedProps: {
          type: 'info',
          showForExternal: e.showForExternal
        }
      }
    ))
  },
  CALENDAR_EVENTS_AS_EVENTS_EXTERNAL: (state, getters) => {
    const filteredEvents = state.calendarEvents.filter((c) => c.showForExternal === true)
    return filteredEvents.map(e => (
      {
        id: e.id,
        title: e.title,
        start: e.start,
        end: e.end,
        color: e.color === null ? '#000000' : e.color,
        textColor: '#ffffff',
        resourceId: e.resourceId,
        className: 'calendarOrderEvent calendarCustomEvent',
        borderColor: 'transparent',
        allDay: false,
        editable: false,
        extendedProps: {
          type: 'info',
          showForExternal: e.showForExternal
        }
      }
    ))
  },
  EVENTS: (state, mygetters) => {
    return [ ...getters.CALENDAR_EVENTS_AS_EVENTS(state, mygetters), ...getters.ORDERS_AS_EVENTS(state, mygetters) ]
  },
  EVENTSEXTERNAL: (state, mygetters) => {
    return [ ...getters.CALENDAR_EVENTS_AS_EVENTS_EXTERNAL(state, mygetters), ...getters.ORDERS_AS_EXTERNAL_EVENTS(state, mygetters) ]
  },
  ORDERS_IN_DATE_RANGE: (state, getters) => (start, end) => {
    return state.dateRangedOrders.filter(order => {
      if (order.data.DecidedLoadingDate !== undefined) {
        order.data.DateDeliveryLate = undefined
        if (moment(order.data.DecidedLoadingDate).isBetween(start, end)) {
          return true
        }
      }
      if (order.data.DecidedDeliveryDate !== undefined && order.data.DecidedDeliveryDate !== '') {
        if (moment(order.data.DecidedDeliveryDate).isBetween(start, end)) {
          return true
        }
      }
      if (order.data.DateDeliveryLate !== undefined && order.data.DateDeliveryLate !== '') {
        if (moment(order.data.DateDeliveryLate).isBetween(start, end)) {
          return true
        }
      }
      return false
    })
  }
}

const mutations = {
  SET_ARCHIVED_ORDERS: (state, payload) => {
    state.archivedOrders = payload
  },
  SET_DATE_RANGED_ORDERS: (state, payload) => {
    state.dateRangedOrders = payload
  },
  SET_ORDERS_AS_RESOURCES: (state, payload) => {
    state.ordersAsResources = payload.orders
  },
  SET_CUSTOMERPLACES: (state, payload) => {
    state.customerPlaces = payload
  },
  REMOVE_ARCHIVED_ORDER: (state, payload) => {
    const i = state.archivedOrders.map(item => item.id).indexOf(payload)
    state.archivedOrders.splice(i, 1)
  },
  SET_ARCHIVED_ORDER: (state, payload) => {
    state.archivedOrders = [
      ...state.archivedOrders.map(item => item.id !== payload.id ? item : { ...item, ...payload })
    ]
  },
  ADD_CALENDAR_EVENT: (state, payload) => {
    state.calendarEvents.push(payload)
  },
  SET_CALENDAR_EVENT: (state, payload) => {
    state.calendarEvents = [
      ...state.calendarEvents.map(item => item.id !== payload.id ? item : { ...item, ...payload })
    ]
  },
  SET_CALENDAR_EVENTS: (state, payload) => {
    state.calendarEvents = payload
  },
  REMOVE_CALENDAR_EVENT: (state, payload) => {
    const i = state.calendarEvents.map(item => item.id).indexOf(parseInt(payload))
    state.calendarEvents.splice(i, 1)
  }
}

const actions = {
  GET_DATE_RANGED_ORDERS: async (context, payload) => {
    const { data } = await remote().get('/api/orders/orders-for-planning')
    context.commit('SET_CUSTOMERPLACES', data.customerPlaces)
    context.commit('SET_DATE_RANGED_ORDERS', data.orders)
  },
  GET_DATE_RANGED_ORDERS_ARCHIVE: async (context, payload) => {
    const { data } = await remote().get('/api/orders/orders-for-planning-archive')
    context.commit('SET_CUSTOMERPLACES', data.customerPlaces)
    context.commit('SET_DATE_RANGED_ORDERS', data.orders)
  },
  GET_ORDERS_AS_RESOURCES: async (context, payload) => {
    const { data } = await remote().get('/api/orders/orders-as-resources')
    context.commit('SET_ORDERS_AS_RESOURCES', data)
  },
  GET_ARCHIVED_ORDERS: async (context, payload) => {
    const { data } = await remote().get('/api/orders/by-state/arkiverad')
    context.commit('SET_ARCHIVED_ORDERS', data)
  },
  DELETE_ORDER: async (context, payload) => {
    await remote().delete('/api/orders/' + payload)
    context.commit('REMOVE_ARCHIVED_ORDER', payload)
  },
  GET_CALENDAR_EVENTS: async (context, payload) => {
    const { data } = await remote().get('/api/calendarEvents')
    context.commit('SET_CALENDAR_EVENTS', data)
  },
  GET_CALENDAR_EVENTS_ARCHIVE: async (context, payload) => {
    const { data } = await remote().get('/api/calendarEventsArchive')
    context.commit('SET_CALENDAR_EVENTS', data)
  },
  CREATE_CALENDAR_EVENT: async (context, payload) => {
    const { data } = await remote().post('/api/calendarEvents', { calendarEvent: payload })
    context.commit('ADD_CALENDAR_EVENT', data)
  },
  SET_CALENDAR_EVENT: async (context, payload) => {
    const { data } = await remote().put('/api/calendarEvents/' + payload.id, { calendarEvent: payload })
    context.commit('SET_CALENDAR_EVENT', data)
  },
  DELETE_CALENDAR_EVENT: async (context, payload) => {
    await remote().delete('/api/calendarEvents/' + payload)
    context.commit('REMOVE_CALENDAR_EVENT', payload)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/order.js